import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';

const styles = theme => ({
	h1: {
		color: '#0277bd',
		fontSize: '48px',
		fontWeight: 200,
		margin: 0,
	},
	icon: {
		fontSize: '48px',
		fontWeight: 200,
	},
	h1icon: {
		color: 'inherit',
		padding: '0 5px',
	},
});

class ShiftMaker extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			list: [],
			daysOff: [],
			note: '',
		};
	}

	componentDidMount() {
		this.setState({ user: this.props.user });
		if (this.props.date) {
			this.setState({ note: this.props.date.note });
		}
	}

	componentDidUpdate(prevProps) {
		if (!_.isEqual(prevProps.user, this.props.user)) {
			this.setState({ user: this.props.user });
		}
	}

	handleChange = event => {
		this.setState({ [event.target.name]: event.target.value });
	};

	pickshift = shift => {
		this.props.pickShift(shift, this.state.note);
	};

	render() {
		if (this.props.date === null || this.state.moment === null) return null;

		const { classes } = this.props;
		return (
			<div>
				<h1 className={classes.h1}>Choose a Shift</h1>
				<div>
					Add a note:
					<input name="note" id="note" value={this.state.note} onChange={this.handleChange} />
				</div>
				<button onClick={() => this.pickshift(3)}>Down Under</button>
				<button onClick={() => this.pickshift(1)}>Upstairs Day</button>
				<button onClick={() => this.pickshift(2)}>Upstairs Night</button>
				<button onClick={() => this.pickshift(4)}>Back Bar</button>
				<button onClick={() => this.pickshift(5)}>Security</button>
			</div>
		);
	}
}

export default withStyles(styles, { withTheme: true })(ShiftMaker);
